import { FC, useEffect } from "react";
import "./styles.scss";
import { NumberInput as CarbonNumberInput } from "carbon-components-react";

interface NumberInputProps {
  label: string;
  name: string;
  control: any;
  Controller: any;
  setValue?: Function;
  watch?: Function;
  error?: string;
  size?: string;
  placeholderText?: string;
  helperText?: string;
  disabled?: boolean;
  toggleValue?: boolean;
  hideSteppers?: boolean;
  resetField?: any;
  defaultValue?: number;
  className?: string;
}

const NumberInput: FC<NumberInputProps> = (props) => {
  const {
    name,
    label,
    error,
    disabled,
    control,
    Controller,
    setValue = () => {},
    watch = () => {},
    toggleValue,
    placeholderText,
    helperText = false,
    size = "large",
    hideSteppers = true,
    resetField,
    defaultValue,
    className,
  } = props;

  // watches for any changes to field and get the value
  const fieldToWatch = watch(name);

  useEffect(() => {
    if (toggleValue) {
      // this setValue is what triggers the watch above
      setValue(name, "unknown", { shouldValidate: true });
    } else if (!toggleValue && resetField) {
      setValue(name, defaultValue);
      resetField(name);
    } else if (!toggleValue) {
      setValue(name, defaultValue);
    }
  }, [toggleValue]);

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue, {
        shouldValidate: true,
      });
    }
  }, []);

  return (
    <div className={`${size} ${className}`}>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, onBlur } }) => (
          <CarbonNumberInput
            id={name}
            label={label}
            // set the watched field value ('unknown') as the placeholder instead of directly changing the value
            // since we are using uncontrolled components
            placeholder={fieldToWatch || placeholderText}
            helperText={helperText}
            disabled={disabled || toggleValue}
            invalid={!!error}
            invalidText={error}
            onChange={(value) => {
              onChange(value);
            }}
            onBlur={onBlur}
            hideSteppers={hideSteppers}
            defaultValue={defaultValue || null}
            value={fieldToWatch || placeholderText}
          />
        )}
      />
    </div>
  );
};

export default NumberInput;
